import {
  ACTION_GET_ENERGY_SAVING_LIST,
  ACTION_GET_ENERGY_SAVING_LIST_SUCCESS,
  ACTION_GET_ENERGY_SAVING_RESET,
} from 'src/redux/actions/energySavingAction/energySavingActionList'

const INITIAL_STATE = {
  data: {},
  loading: false,
}

const energySavingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_GET_ENERGY_SAVING_RESET:
      return {
        ...state,
        data: {},
        loading: false,
      }

    case ACTION_GET_ENERGY_SAVING_LIST:
      return {
        ...state,
        loading: true,
      }
    case ACTION_GET_ENERGY_SAVING_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

export default energySavingReducer
